import React, { useState } from 'react';
import Button from '~/components/atom/Button';
import JustificationContainer from '~/components/atom/JustificationContainer';
import GenerateFlowTemplateNameModal from '../GenerateFlowTemplateNameModal';

const text = {
  generateFlowTemplateName:
    'Je bent in het master account. Gebruik deze knop om een flow template te genereren',
};

const NameGenerationButton = ({
  onSubmit,
}: {
  onSubmit: (flowTemplateName: string) => void;
}) => {
  const [showModal, setShowModal] = useState(false);

  return (
    <JustificationContainer>
      <Button
        label={text.generateFlowTemplateName}
        onClick={() => {
          setShowModal(true);
        }}
        pulse
      />

      {showModal && (
        <GenerateFlowTemplateNameModal
          onClose={() => setShowModal(false)}
          onSubmit={value => {
            onSubmit(value);
            setShowModal(false);
          }}
        />
      )}
    </JustificationContainer>
  );
};

export default NameGenerationButton;
